module.exports = __webpack_public_path__ + "efdafce26cc1b602a93eccb9eda9b156.svg";